<template>
	<div class="tw-flex tw-flex-col">
		<div class="card-v2">
			<div class="card-top no-border no-margin">
				<h3>{{ $t('profile.general_info') }}</h3>
			</div>
			<div class="event-detail tw-text-gray-400 tw-pb-3" v-if="tEvent.past">
				<i class="far fa-history"></i>
				<p class="tw-text-sm">{{ $t('events.singular') }} {{ $t('events.has_ended').toLowerCase() }}</p>
			</div>
			<div class="tw-grid tw-grid-cols-2 tw-gap-x-3 tw-gap-y-3">
				<div class="event-detail" v-if="!tEvent.online && tEvent.full_address !== ''">
					<i class="far fa-map-marker-alt"></i>
					<p v-text="tEvent.full_address"></p>
				</div>
				<div class="event-detail">
					<i class="far fa-clock"></i>
					<p>
                        <span class="tw-capitalize">
                        {{ dateInfo.startDay }}
                      </span>
						{{ dateInfo.startDate }}
						<template v-if="!tEvent.all_day">
							{{ $t('general.time_at') }} {{ dateInfo.startTime }}
						</template>
						<template v-if="(dateInfo.endsOnSameDay && !tEvent.all_day) || (!dateInfo.endsOnSameDay && tEvent.all_day) || (!dateInfo.endsOnSameDay && !tEvent.all_day)">
							{{ $t('fields.until') }} <br/><span class="tw-capitalize">{{ dateInfo.endDay }}</span> {{ dateInfo.endDate }}
							<template v-if="!tEvent.all_day">
								{{ $t('general.time_at') }} {{ dateInfo.endTime }}
							</template>
						</template>
					</p>
				</div>
				<div class="event-detail" v-if="tEvent.online && tEvent.url !== '' && tEvent.url_title !== ''">
					<i class="far fa-link"></i>
					<a :href="tEvent.url" target="_blank" v-text="tEvent.url_title" class="secondary-c"></a>
				</div>
				<div class="event-detail" v-if="tEvent.paid && tEvent.price !== ''">
					<i class="far fa-sack-dollar"></i>
					<p>€{{ tEvent.price }}</p>
				</div>
				<div class="event-detail" v-if="tEvent.start_date !== '' && isMember && !tEvent.past">
					<div class="tw-cursor-pointer" @click="addDateToCalendar">
						<i class="fal fa-calendar-plus"></i>
						<span class="tw-underline" v-text="$t('events.add_to_your_calendar')"></span>
					</div>
				</div>
			</div>
		</div>

		<div class="card-v2">
			<p id="event-description" class="tw-leading-loose tw-mb-6" v-html="tEvent.description"></p>
			<div class="tw-flex">
				<div class="tw-flex tw-flex-col tw-mb-6">
					<div class="card-top no-border no-margin">
						<h3 v-text="$t('events.category')"></h3>
					</div>
					<event-category-pill :category="category" class="tw--mt-2"></event-category-pill>
				</div>
			</div>
		</div>

		<tab-topics v-if="isMember || tEvent.status === 'public'" :channelId="tEvent.channel_id" :recent_posts_trans_key="$t('groups.recent_posts')" :impersonating="$user.impersonating"></tab-topics>
	</div>
</template>

<script>
import Global from '@/resources/assets/js/vue/mixins/Global';
import TabTopics from '@/resources/assets/js/vue/components/events_and_groups/tabs/Topics.vue';
import CategoryPill from '@/resources/assets/js/vue/components/events/CategoryPill.vue';
import EventCategory from "../../../lib/models/EventCategory";

export default {
	name: 'EventsTabGeneral',

	mixins: [Global],

	components: {
		'tab-topics': TabTopics,
		'event-category-pill' : CategoryPill,
	},

	data() {
		return {
			user,
		}
	},

	props: {
		tEvent: {
			required: true,
		},
		isMember: {
			required: true,
		},
		dateInfo: {
			required: true,
		},
	},

	computed: {
		category() {
			return EventCategory.find(this.tEvent.category_id);
		},

		live_room(){
			if(this.tEvent.type !== 'live') return false;

			return LiveRoom.find(this.tEvent.live_room.id);
		},

		live_room_participant() {
			if(this.tEvent.type !== 'live' && !this.tEvent.live_room.participants) return false;

			const live_room_participant_id = this.tEvent.live_room.participants.find(p => p.user_id === this.user.id).id;
			return LiveRoomParticipant.find(live_room_participant_id);
		}
	},

	methods: {
		addDateToCalendar() {
			this.$emit('addDateToCalendar');
		},
	}
};
</script>

<style lang="scss" scoped>
.event-detail {
	@apply tw-flex tw-leading-relaxed tw-mr-2;

	i {
		@apply tw-mr-3 tw-pt-1;
	}

	&:last-of-type {
		@apply tw-mb-0;
	}
}

#group-event-icon {
	width: 32px;
	height: 32px;
}
</style>